module.exports = __webpack_public_path__ + "img/php.63689a03.svg";